import { ArrowRight, Lock } from "lucide-react";
import { Link } from "react-router-dom";

export const AgentCard = ({ agent, index }) => {
  const Icon = agent.icon;
  const enabled = agent.enabled !== false;

  const cardClasses = enabled
    ? "group relative flex flex-col h-full p-6 md:p-7 bg-brand-deep/40 backdrop-blur-xl border border-brand-mint/15 rounded-2xl hover:bg-brand-deep/60 hover:border-brand-mint/40 hover:shadow-[0_8px_32px_rgba(160,228,203,0.12)] transition-all duration-300 cursor-pointer overflow-hidden"
    : "relative flex flex-col h-full p-6 md:p-7 bg-brand-deep/25 backdrop-blur-xl border border-brand-mint/10 rounded-2xl opacity-70 cursor-not-allowed overflow-hidden";

  const inner = (
    <>
      {/* corner glow (only when enabled) */}
      {enabled && (
        <div className="pointer-events-none absolute -top-24 -right-24 h-48 w-48 rounded-full bg-brand-mint/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      )}

      <div
        className={`h-12 w-12 rounded-xl bg-brand-deep/80 border flex items-center justify-center mb-5 ${
          enabled
            ? "border-brand-mint/20 text-brand-mint group-hover:scale-110 group-hover:bg-brand-mint/10 group-hover:border-brand-mint/50 transition-all duration-300"
            : "border-brand-mint/10 text-brand-mint/45"
        }`}
      >
        <Icon className="h-6 w-6" strokeWidth={1.75} />
      </div>

      <h3
        data-testid={`agent-card-title-${agent.id}`}
        className={`text-xl font-bold mb-2 tracking-tight ${
          enabled ? "text-brand-mint" : "text-brand-mint/65"
        }`}
      >
        {agent.name}
      </h3>
      <p
        className={`text-sm leading-relaxed flex-grow ${
          enabled ? "text-brand-mint/70" : "text-brand-mint/45"
        }`}
      >
        {agent.description}
      </p>

      <div className="pt-6 mt-auto flex items-center justify-between">
        {enabled ? (
          <span
            data-testid={`agent-card-launch-${agent.id}`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-brand-mint group-hover:text-brand-mintBright transition-colors"
          >
            Launch Agent
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        ) : (
          <span
            data-testid={`agent-card-disabled-${agent.id}`}
            className="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wider text-brand-mint/55 bg-brand-deeper/60 border border-brand-mint/15"
          >
            <Lock className="h-3 w-3" />
            Launch Agent
          </span>
        )}
        <span className="text-xs font-mono text-brand-mint/50 uppercase tracking-widest">
          0{index + 1}
        </span>
      </div>
    </>
  );

  if (!enabled) {
    return (
      <div
        data-testid={`agent-card-${agent.id}`}
        aria-disabled="true"
        className={cardClasses}
        style={{ animationDelay: `${index * 80}ms` }}
      >
        {inner}
      </div>
    );
  }

  return (
    <Link
      to={`/chat/${agent.id}`}
      data-testid={`agent-card-${agent.id}`}
      className={cardClasses}
      style={{ animationDelay: `${index * 80}ms` }}
    >
      {inner}
    </Link>
  );
};

export default AgentCard;
